import { render, staticRenderFns } from "./CatalogSearchResult.vue?vue&type=template&id=c5e304ae&scoped=true"
import script from "./CatalogSearchResult.vue?vue&type=script&lang=ts"
export * from "./CatalogSearchResult.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./CatalogSearchResult.vue?vue&type=style&index=0&id=c5e304ae&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c5e304ae",
  null
  ,true
)

export default component.exports